// extracted by mini-css-extract-plugin
module.exports = {"homeNavItem":"HomeNavItem_homeNavItem__81LBx"};